import {
  Truck, Car, Route, Siren, CircleDot, LifeBuoy, BatteryCharging, KeyRound, Fuel, Anchor, Bike, Container, Wrench,
} from "lucide-react";

export const SERVICES = [
  { id: "flatbed", icon: Truck, tow: true },
  { id: "local_tow", icon: Car, tow: true },
  { id: "long_distance", icon: Route, tow: true },
  { id: "accident", icon: Siren, tow: true },
  { id: "flat_tire", icon: CircleDot, tow: false },
  { id: "spare_tire", icon: LifeBuoy, tow: false },
  { id: "jump_start", icon: BatteryCharging, tow: false },
  { id: "lockout", icon: KeyRound, tow: false },
  { id: "fuel", icon: Fuel, tow: false },
  { id: "winch", icon: Anchor, tow: false },
  { id: "motorcycle", icon: Bike, tow: true },
  { id: "transport", icon: Container, tow: true },
  { id: "other", icon: Wrench, tow: false },
];

export const serviceById = (id) => SERVICES.find((s) => s.id === id);

export const STATUSES = ["new", "contacted", "quoted", "accepted", "driver_assigned", "en_route", "completed", "cancelled"];

export const STATUS_COLORS = {
  new: "bg-yellow-400/15 text-yellow-300 border-yellow-400/40",
  contacted: "bg-orange-400/15 text-orange-300 border-orange-400/40",
  quoted: "bg-amber-400/15 text-amber-200 border-amber-400/40",
  accepted: "bg-sky-400/15 text-sky-300 border-sky-400/40",
  driver_assigned: "bg-violet-400/15 text-violet-300 border-violet-400/40",
  en_route: "bg-blue-400/15 text-blue-300 border-blue-400/40",
  completed: "bg-emerald-400/15 text-emerald-300 border-emerald-400/40",
  cancelled: "bg-red-500/15 text-red-300 border-red-500/40",
};

export const VEHICLE_TYPES = ["sedan", "suv", "pickup", "van", "motorcycle", "other"];
export const COMMON_MAKES = [
  "Acura", "Audi", "BMW", "Buick", "Cadillac", "Chevrolet", "Chrysler", "Dodge", "Ford", "GMC", "Harley-Davidson",
  "Honda", "Hyundai", "Infiniti", "Jeep", "Kia", "Lexus", "Lincoln", "Mazda", "Mercedes-Benz", "Mitsubishi",
  "Nissan", "Ram", "Subaru", "Tesla", "Toyota", "Volkswagen", "Volvo", "Yamaha",
];
export const COLORS = ["black", "white", "silver", "gray", "red", "blue", "green", "brown", "gold", "other"];
